<template>
	<main class="common-main-container">
		<div
			style="position: fixed; top: 20px; z-index: 100; backdrop-filter: blur(2px)"
			v-if="mainLoader"
		>
			<Spinner />
		</div>
		<header>
			<h1 class="d-flex align-items-center">
				Transactions
			</h1>
		</header>
		<body class="my-2 transaction-container">
			<main class="main-overflow">
				<!-- Metrics Section -->
				<section class="metrics-cards-row">
					<!-- Card 1 -->
					<div class="metric-card t-earnings-card position-relative">
						<div class="t-icon">
							<img src="../assets/transaction/earning.svg" alt="" />
						</div>
						<div class="mt-auto">
							<h3 v-if="totalEarnings !== null" class="t-value t-earn-val mb-2">
								{{ totalEarnings.toLocaleString("en-IN") }}
							</h3>
							<b-skeleton v-else width="100px" height="26px"></b-skeleton>
							<p class="t-label t-earn-label">Total Earnings</p>
						</div>
						<img
							class="position-absolute"
							style="bottom: 0; right: 0;"
							src="../assets/transaction/earn-back.svg"
							alt=""
						/>
					</div>

					<!-- Card 2 -->
					<div class="metric-card t-transactions-card">
						<div class="t-icon">
							<img src="../assets/transaction/transaction.svg" alt="" />
						</div>
						<div class="mt-auto">
							<h3 v-if="totalTransactions" class="t-value t-trans-val mb-2">
								{{ totalTransactions }}
							</h3>
							<b-skeleton v-else width="100px" height="26px"></b-skeleton>
							<p class="t-label t-trans-label">Total Transactions</p>
						</div>
					</div>

					<!-- Divider -->
					<div class="t-divider"></div>

					<!-- Card 3 -->
					<div class="metric-card t-course-card position-relative">
						<div>
							<span class="t-popular-tag">POPULAR</span>
							<h4 v-if="topicName" class="t-course-title">
								{{ topicName }}
							</h4>
							<b-skeleton v-else width="150px" height="26px"></b-skeleton>
							<p v-if="testName" class="t-course-sub">{{ testName }}</p>
							<b-skeleton v-else width="100px" height="20px"></b-skeleton>
						</div>
						<div
							class="mt-auto d-flex justify-content-between align-items-end w-100"
						>
							<p v-if="purchaseCount" class="t-course-enrolled">
								Purchase Count: <b>{{ purchaseCount }}</b>
							</p>
							<b-skeleton v-else width="100px" height="18px"></b-skeleton>
							<!-- <div class="t-chevron">
								<img src="../assets/transaction/right-arrow.svg" alt="" />
							</div> -->
						</div>
					</div>

					<!-- Card 4 -->
					<div
						class="metric-card t-withdraw-card position-relative pointer"
						v-if="roles.includes('HIRE3X_WALLET')"
						@click="openWallet()"
					>
						<div class="t-icon">
							<img src="../assets/transaction/withdraw.svg" alt="" />
						</div>
						<div>
							<h4 class="t-withdraw-title mb-2">Billing Details</h4>
						</div>
						<div
							class="mt-auto d-flex justify-content-between align-items-end w-100"
						>
							<p class="t-withdraw-sub">
								Review and manage billing preferences
							</p>
							<div class="t-chevron">
								<img src="../assets/transaction/right-arrow.svg" alt="" />
							</div>
						</div>
					</div>
				</section>
				<section class="transaction-search-section">
					<h4 class="font-lato fw-500 fs-16 color-black mb-3">
						Assessments
					</h4>
					<div class="d-flex align-items-center justify-content-between">
						<div class="position-relative w-50 searchtransaction">
							<img
								class="search-image-position"
								src="../assets/common-icons/magni.svg"
							/>
							<b-form-input
								class="config-search-input"
								placeholder="Search"
								type="search"
								@update="performSearch"
								v-model="searchConfig"
								debounce="500"
								clearable
							>
							</b-form-input>
						</div>
						<div class="d-flex align-items-center gap-3">
							<div
								v-closable="{
									exclude: ['ref1'],
									handler: 'closeDpd',
								}"
								class="position-relative"
							>
								<div
									v-if="appliedTestID || appliedDateFilter || appliedGroupID"
									class="red-dot"
								></div>
								<b-button
									ref="ref1"
									class="new-addBtn"
									@click="showFilter = !showFilter"
								>
									<img
										class="mr-2"
										src="../assets/common-icons/whitefilter.svg"
										alt=""
									/>
									Filter
								</b-button>
								<div
									v-if="showFilter"
									class="config-filter-dropdown"
									style="min-width: 320px;"
								>
									<SingleSelect
										:optionsArray="dateOptions"
										:text="'Transaction Date:'"
										v-model="selectedDateFilter"
									/>
									<div class="d-flex justify-content-between">
										<DateField
											class="mt-2"
											style="width: 48%"
											:showDateTime="false"
											text="From Date:"
											:disabled="selectedDateFilter.value !== 'custom'"
											v-model="customFromDate"
										/>
										<DateField
											class="mt-2"
											style="width: 48%"
											:showDateTime="false"
											text="To Date:"
											:disabled="selectedDateFilter.value !== 'custom'"
											v-model="customToDate"
										/>
									</div>
									<p
										v-if="dateError"
										class="text-danger m-0 mt-1"
										style="font-size: 12px"
									>
										Both dates are required.
									</p>
									<SingleSelect
										class="mt-2"
										:optionsArray="assessmentOptions"
										:text="'Assessment Name:'"
										v-model="selectedTest"
									/>
									<SingleSelect
										class="mt-2"
										:optionsArray="groupOptions"
										:text="'Group:'"
										v-model="selectedGroup"
									/>
									<div
										class="d-flex align-items-center justify-content-between filter-buttons mt-4"
									>
										<b-button @click="cancelFilter">Cancel</b-button>
										<span>
											<b-button class="mr-3" @click="resetFilter"
												>Reset</b-button
											>
											<b-button @click="applyFilter">Apply</b-button>
										</span>
									</div>
								</div>
							</div>
							<b-button class="new-addBtn" @click="exportExcelReport">
								Export Excel
							</b-button>
						</div>
					</div>
					<div class="tran-table-container mt-3">
						<section class="header font-lato fw-600 fs-14 color-72738e mx-1">
							<div class="one pl-4">
								Assessment Name
								<template v-if="sortColumn == 'assessmentName'">
									<img
										@click="sort('assessmentName')"
										v-if="sorting == true"
										src="../assets/common-icons/upsort.svg"
										alt=""
										class="pointer ml-1"
									/>
									<img
										v-else
										@click="sort('assessmentName')"
										src="../assets/common-icons/downsort.svg"
										alt=""
										class="pointer ml-1"
									/>
								</template>
								<img
									v-else
									@click="sort('assessmentName')"
									src="../assets/common-icons/nosort.svg"
									alt=""
									class="pointer ml-1"
								/>
							</div>
							<div class="two">
								Candidate
								<template v-if="sortColumn == 'candidateName'">
									<img
										@click="sort('candidateName')"
										v-if="sorting == true"
										src="../assets/common-icons/upsort.svg"
										alt=""
										class="pointer ml-1"
									/>
									<img
										v-else
										@click="sort('candidateName')"
										src="../assets/common-icons/downsort.svg"
										alt=""
										class="pointer ml-1"
									/>
								</template>
								<img
									v-else
									@click="sort('candidateName')"
									src="../assets/common-icons/nosort.svg"
									alt=""
									class="pointer ml-1"
								/>
							</div>
							<div class="two-b">
								Candidate Email
							</div>
							<div class="three">
								Payment ID
								<template v-if="sortColumn == 'paymentID'">
									<img
										@click="sort('paymentID')"
										v-if="sorting == true"
										src="../assets/common-icons/upsort.svg"
										alt=""
										class="pointer ml-1"
									/>
									<img
										v-else
										@click="sort('paymentID')"
										src="../assets/common-icons/downsort.svg"
										alt=""
										class="pointer ml-1"
									/>
								</template>
								<img
									v-else
									@click="sort('paymentID')"
									src="../assets/common-icons/nosort.svg"
									alt=""
									class="pointer ml-1"
								/>
							</div>
							<div class="four">
								Transaction Date
								<template v-if="sortColumn == 'createdAt'">
									<img
										@click="sort('createdAt')"
										v-if="sorting == true"
										src="../assets/common-icons/upsort.svg"
										alt=""
										class="pointer ml-1"
									/>
									<img
										v-else
										@click="sort('createdAt')"
										src="../assets/common-icons/downsort.svg"
										alt=""
										class="pointer ml-1"
									/>
								</template>
								<img
									v-else
									@click="sort('createdAt')"
									src="../assets/common-icons/nosort.svg"
									alt=""
									class="pointer ml-1"
								/>
							</div>
							<div class="ts-amount">
								Amount
								<template v-if="sortColumn == 'paymentBreakdown.amount'">
									<img
										@click="sort('paymentBreakdown.amount')"
										v-if="sorting == true"
										src="../assets/common-icons/upsort.svg"
										alt=""
										class="pointer ml-1"
									/>
									<img
										v-else
										@click="sort('paymentBreakdown.amount')"
										src="../assets/common-icons/downsort.svg"
										alt=""
										class="pointer ml-1"
									/>
								</template>
								<img
									v-else
									@click="sort('paymentBreakdown.amount')"
									src="../assets/common-icons/nosort.svg"
									alt=""
									class="pointer ml-1"
								/>
							</div>
							<div class="five">
								Group Name
							</div>
							<div class="six"></div>
						</section>
						<section class="table-scroll mt-2 px-1">
							<div v-if="LoaderStatus">
								<div
									v-for="i in 5"
									:key="'skel' + i"
									class="tran-row d-flex align-items-center fs-15 mb-2 py-3"
								>
									<div class="grey-line"></div>
									<div class="one px-4">
										<b-skeleton width="80%"></b-skeleton>
									</div>
									<div class="two"><b-skeleton width="60%"></b-skeleton></div>
									<div class="two-b"><b-skeleton width="70%"></b-skeleton></div>
									<div class="three"><b-skeleton width="70%"></b-skeleton></div>
									<div class="four"><b-skeleton width="50%"></b-skeleton></div>
									<div class="five">
										<b-skeleton width="80px" height="26px"></b-skeleton>
									</div>
									<div class="six">
										<b-skeleton type="avatar" size="24px"></b-skeleton>
									</div>
								</div>
							</div>
							<template v-else>
								<div
									v-for="(item, index) in transactions"
									:key="index"
									class="tran-row d-flex align-items-center fs-15 fw-400 color-72738e font-lato mb-2"
								>
									<div class="grey-line"></div>
									<div class="one px-4 text-truncate">
										<span
											v-b-popover.hover.bottom="item.assessmentName"
											style="max-width: 100%"
											class="d-inline-block text-truncate"
											>{{ item.assessmentName }}</span
										>
									</div>
									<div class="two text-break">
										{{ item.candidateName }}
									</div>
									<div class="two-b text-break">
										{{ item.email }}
									</div>
									<div class="three">
										{{ item.paymentID }}
									</div>
									<div class="four">
										{{ formatDate(item.createdAt) }}
									</div>
									<div class="ts-amount">
										{{ item.paymentBreakdown.amount }}
									</div>
									<div class="five">
										{{ item.groupType === "G" ? item.groupName : "Individual" }}
									</div>
									<div class="six">
										<img
											src="../assets/common-icons/view.svg"
											alt=""
											class="cursor-pointer"
											@click="openModal(item)"
											style="cursor:pointer;"
										/>
									</div>
								</div>
								<div
									v-if="transactions.length == 0"
									class="d-flex flex-column align-items-center justify-content-center h-100"
								>
									<span v-if="searchConfig"
										>No results for "{{ searchConfig }}"</span
									>
									<span v-else>No data found.</span>
								</div>
							</template>
						</section>
						<section
							v-if="transactions.length > 0"
							class="acs-paginaTion-new d-flex justify-content-between align-items-center min-width-1200"
						>
							<div class="d-flex">
								<span class="acs-gotopage-text mr-2 p-1">Go to page</span>
								<div class="acs-pagination-num">
									<b-form-input
										class="no-number"
										type="text"
										v-model.trim="goToPage"
										@keyup.enter="
											goToPage === null || goToPage == '' || iscontainsNumber
												? ''
												: goToPageNo(goToPage)
										"
									></b-form-input>
								</div>

								<div class="acs-pagination-addbtn">
									<b-button
										:disabled="
											goToPage === null || goToPage == '' || iscontainsNumber
										"
										@click="goToPageNo(goToPage)"
									>
										<img src="../assets/transaction/page-right.svg" alt="" />
									</b-button>
								</div>
							</div>
							<div class="d-flex justify-content-center pagination ml-135">
								<b-pagination
									v-model.number="currentPage"
									@input="goToPageNum()"
									:total-rows="total"
									:per-page="count"
									align="center"
									first-number
									last-number
								>
									<template #prev-text
										><span><img src="../assets/leftvector.svg" alt="" /> </span
									></template>
									<template #next-text
										><span><img src="../assets/rightarrow.svg" alt=""/></span
									></template>
								</b-pagination>
							</div>
							<div class="d-flex align-items-center">
								<PaginationCountSelect
									:pagecount="count"
									@update-value="getPageCount"
								/>
								<div
									class="acs-gotopage-text mr-2 ml-4 d-flex align-items-center justify-content-end"
								>
									Results :
									<span class="mr-1" v-if="pageStart > total">0</span
									><span class="mr-1" v-else>{{ pageStart }}</span> -
									{{ pageEnd }} <span class="pl-1"></span> of
									<span class="pr-1"></span>{{ total }}
								</div>
							</div>
						</section>
					</div>
				</section>
			</main>
		</body>
		<TransactionDetailsModal
			:isOpen="isModalOpen"
			:transaction="selectedTransaction"
			@close="isModalOpen = false"
		/>
	</main>
</template>

<script>
import SingleSelect from "@/components/InputComponents/SingleSelect.vue";
import Spinner from "@/components/fixedcomponents/Spinner.vue";
import PaginationCountSelect from "@/components/fixedcomponents/PaginationCountSelect.vue";
import DateField from "@/components/InputComponents/DateField.vue";
import {
	getOrderTransactions,
	getTransactionSummary,
	exportOrderTransactionsExcel,
} from "../utils/apiFunctions";
import TransactionDetailsModal from "@/components/modals/TransactionDetailsModal.vue";
import { mapGetters } from "vuex";
export default {
	name: "TransactionList",
	components: {
		SingleSelect,
		Spinner,
		PaginationCountSelect,
		TransactionDetailsModal,
		DateField,
	},
	data() {
		return {
			LoaderStatus: false,
			mainLoader: false,
			transactions: [],
			total: 0,
			totalTransactions: 0,
			pageStart: 0,
			pageEnd: 0,
			totalPages: 0,
			currentPage: 1,
			count: 10,
			searchConfig: "",
			sortColumn: "createdAt",
			sorting: false, // false is desc (-1), true is asc (1)
			goToPage: null,
			dataDpd: [{ text: "abc", value: 1 }],
			selectedTransaction: {},
			isModalOpen: false,
			totalEarnings: null,
			purchaseCount: 0,
			topicName: "",
			testName: "",
			showFilter: false,
			assessmentOptions: [],
			groupOptions: [],
			selectedDateFilter: { text: "Select", value: null },
			selectedTest: { text: "Select", value: null },
			selectedGroup: { text: "Select", value: null },
			customFromDate: null,
			customToDate: null,
			dateError: false,
			appliedTestID: "",
			appliedGroupID: "",
			appliedDateFilter: "",
			appliedCustomFromDate: null,
			appliedCustomToDate: null,
			dateOptions: [
				{ text: "Today", value: "today" },
				{ text: "This week", value: "this_week" },
				{ text: "This month", value: "this_month" },
				{ text: "This year", value: "this_year" },
				{ text: "Custom", value: "custom" },
			],
		};
	},
	created() {
		this.mainLoader = true;
		this.getTransactionList();
		this.getTransactionSummary();
	},
	computed: {
		iscontainsNumber() {
			return !/^[1-9]\d*$/.test(this.goToPage);
		},
		...mapGetters(["roles"]),
	},
	methods: {
		openWallet(){
      		window.open("https://utility.hire3x.com/login", "_blank");
		},
		async exportExcelReport() {
			try {
				let payload = {
					excel_export: true,
				};
				const res = await exportOrderTransactionsExcel(payload);
				if (res.status == 200) {
					const url = window.URL.createObjectURL(
						new Blob([res.data], {
							type:
								"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
						})
					);

					const link = document.createElement("a");
					link.href = url;
					link.download = "Transactions Report.xlsx";
					link.click();
				}
			} catch (error) {
				console.log(error);
			}
		},
		async getTransactionList() {
			this.LoaderStatus = true;
			try {
				let payload = {
					sortBy: this.sortColumn,
					sortOrder: this.sorting ? 1 : -1,
					page: this.currentPage - 1,
					count: this.count,
					searchQuery: this.searchConfig,
					filters: {
						testID: this.appliedTestID,
						groupID: this.appliedGroupID,
						dateFilter: this.appliedDateFilter,
					},
				};
				if (this.appliedDateFilter === "custom") {
					if (this.appliedCustomFromDate) {
						let parts = this.appliedCustomFromDate.split("-");
						if (parts.length === 3) {
							payload.filters.fromDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
						}
					}
					if (this.appliedCustomToDate) {
						let parts = this.appliedCustomToDate.split("-");
						if (parts.length === 3) {
							payload.filters.toDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
						}
					}
				}
				// You usually get adminuserID from vuex or storage, we can pass it if required, but axios likely handles it or it's a cookie
				const res = await getOrderTransactions(payload);
				if (res.status == 200) {
					const responseData = res.data.data || {};
					this.transactions = responseData.results || [];
					const metadata = responseData.metadata || {};
					this.total = metadata.totalCount || 0;
					if (this.totalTransactions == 0) {
						this.totalTransactions = this.total;
					}

					if (this.total > 0) {
						this.pageStart = (this.currentPage - 1) * this.count + 1;
						this.pageEnd = Math.min(this.currentPage * this.count, this.total);
					} else {
						this.pageStart = 0;
						this.pageEnd = 0;
					}
					this.mainLoader = false;

					this.totalPages =
						metadata.totalPages ||
						Math.ceil(parseInt(this.total) / parseInt(this.count));
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.LoaderStatus = false;
			}
		},
		async getTransactionSummary() {
			try {
				const res = await getTransactionSummary();
				if (res.status == 200) {
					this.totalEarnings = res.data.data.totalEarnings;
					this.topicName = res.data.data.mostPopularAssessment?.topicName;
					this.testName = res.data.data.mostPopularAssessment?.testName;
					this.purchaseCount =
						res.data.data.mostPopularAssessment?.purchase_count;

					const testOpts = res.data.data.testOptions || [];
					this.assessmentOptions = testOpts.map((opt) => ({
						text: opt.testName,
						value: opt.testID,
					}));

					const groupOpts = res.data.data.groupOptions || [];
					this.groupOptions = groupOpts.map((opt) => ({
						text: opt.groupName,
						value: opt.groupID,
					}));
				}
			} catch (error) {
				console.error(error);
			}
		},
		applyFilter() {
			if (this.selectedDateFilter.value === "custom") {
				if (!this.customFromDate || !this.customToDate) {
					this.dateError = true;
					return;
				}
			}
			this.dateError = false;
			this.appliedTestID = this.selectedTest.value || "";
			this.appliedGroupID = this.selectedGroup.value || "";
			this.appliedDateFilter = this.selectedDateFilter.value || "";
			this.appliedCustomFromDate = this.customFromDate;
			this.appliedCustomToDate = this.customToDate;
			this.currentPage = 1;
			this.showFilter = false;
			this.getTransactionList();
		},
		resetFilter() {
			this.dateError = false;
			this.selectedDateFilter = { text: "Select", value: null };
			this.selectedTest = { text: "Select", value: null };
			this.selectedGroup = { text: "Select", value: null };
			this.customFromDate = null;
			this.customToDate = null;
			this.appliedTestID = "";
			this.appliedGroupID = "";
			this.appliedDateFilter = "";
			this.appliedCustomFromDate = null;
			this.appliedCustomToDate = null;
			this.currentPage = 1;
			this.getTransactionList();
		},
		cancelFilter() {
			let dtOpt = this.dateOptions.find(
				(o) => o.value === this.appliedDateFilter
			);
			this.selectedDateFilter = dtOpt || { text: "Select", value: null };

			let tsOpt = this.assessmentOptions.find(
				(o) => o.value === this.appliedTestID
			);
			this.selectedTest = tsOpt || { text: "Select", value: null };

			let grpOpt = this.groupOptions.find(
				(o) => o.value === this.appliedGroupID
			);
			this.selectedGroup = grpOpt || { text: "Select", value: null };

			this.customFromDate = this.appliedCustomFromDate;
			this.customToDate = this.appliedCustomToDate;
			this.dateError = false;
			this.showFilter = false;
		},
		closeDpd() {
			if (this.showFilter) {
				this.cancelFilter();
			}
		},
		performSearch() {
			this.currentPage = 1;
			this.getTransactionList();
		},
		openModal(item) {
			this.selectedTransaction = item;
			this.isModalOpen = true;
		},
		sort(column) {
			if (this.sortColumn === column) {
				this.sorting = !this.sorting;
			} else {
				this.sortColumn = column;
				this.sorting = true;
			}
			this.getTransactionList();
		},
		goToPageNo(index) {
			if (index === null || index === "" || this.iscontainsNumber) return;
			this.currentPage = Math.min(Math.max(1, index), this.totalPages);
			this.goToPage = null;
			this.getTransactionList();
		},
		goToPageNum() {
			this.getTransactionList();
		},
		getPageCount(value) {
			this.count = value;
			this.currentPage = 1;
			this.getTransactionList();
		},
		formatDate(dateStr) {
			if (!dateStr) return "";
			const d = new Date(dateStr);
			const day = ("0" + d.getDate()).slice(-2);
			const month = ("0" + (d.getMonth() + 1)).slice(-2);
			const year = d.getFullYear();
			return `${day}-${month}-${year}`;
		},
	},
};
</script>

<style>
/* configuration designs start */
.transaction-container {
	max-width: 100%;
	margin: 0;
	padding: 0;
	border-radius: 4px;
	overflow: hidden;
}

.transaction-container .main-overflow {
	overflow-y: auto;
	height: calc(100vh - 160px);
}

.metrics-cards-row {
	display: flex;
	align-items: stretch;
	gap: 12px;
	padding-bottom: 12px;
	overflow-x: auto;
}

.metric-card {
	flex: 1;
	border-radius: 8px;
	padding: 14px 18px;
	display: flex;
	flex-direction: column;
	min-width: 220px;
	box-sizing: border-box;
	box-shadow: 0px 4px 20px 0px #c4c4c480;
}

.t-earnings-card {
	background: #f8fcf8;
	border: 1px solid #ceeccf;
}

.t-transactions-card,
.t-course-card,
.t-withdraw-card {
	background: #ffffff;
	border: 1px solid #eaedf3;
}

.t-course-card {
	min-width: 300px;
	flex: 1;
}

.t-withdraw-card {
	min-width: 240px;
}

.t-icon {
	margin-bottom: 30px;
}
.t-value {
	font-family: "Lato", sans-serif;
	font-size: 22px;
	font-weight: 600;
	margin: 0 0 2px 0;
}

.t-earn-val,
.t-earn-label {
	color: #3d8200;
}
.t-trans-val,
.t-trans-label {
	color: #555b7d;
}

.t-label {
	font-family: "Lato", sans-serif;
	font-size: 16px;
	margin: 0;
	font-weight: 500;
}

.t-divider {
	width: 1px;
	background: #c4c4c4;
	margin: 8px 0;
}

.t-popular-tag {
	background: linear-gradient(
		90deg,
		rgba(114, 115, 142, 0.4004) -59.37%,
		rgba(114, 115, 142, 0.77) 100%
	);

	color: white;
	font-family: "Lato", sans-serif;
	font-size: 10px;
	font-weight: 700;
	padding: 3px 8px;
	border-radius: 4px;
	display: inline-block;
	margin-bottom: 12px;
}
.t-course-title {
	font-family: "Lato", sans-serif;
	font-size: 18px;
	font-weight: 600;
	color: #333333;
	line-height: 1.4;
	margin: 0 0 6px 0;
}
.t-course-sub {
	font-family: "Lato", sans-serif;
	font-size: 14px;
	color: #4b5563;
	margin: 0 0 0px 0;
}
.t-course-enrolled {
	font-family: "Montserrat", sans-serif;
	font-size: 12px;
	color: #72738e;
	margin: 0;
}
.t-course-enrolled b {
	color: #555b7d;
	font-weight: 600;
}

.t-withdraw-title {
	font-family: "Lato", sans-serif;
	font-size: 18px;
	font-weight: 600;
	color: #333333;
	margin: 0 0 4px 0;
}
.t-withdraw-sub {
	font-family: "Montserrat", sans-serif;
	font-size: 12px;
	color: #72738e;
	margin: 0;
}

.mt-auto {
	margin-top: auto;
}
.transaction-search-section {
	background-color: #ffffff;
	border-radius: 8px;
	box-shadow: 0px 0px 18px 0px #00000029;
	padding: 15px;
}
.tran-table-container {
	width: 100%;
	overflow-x: auto;
	padding-bottom: 5px;
}
.tran-table-container .header {
	background: #72738e14;
	display: flex;
	align-items: center;
	height: 45px;
	min-width: 1197px;
}
.one {
	width: 15%;
}
.two {
	width: 15%;
}
.two-b {
	width: 15%;
}
.three {
	width: 15%;
}
.four {
	width: 12%;
}
.five {
	width: 10%;
}
.six {
	width: 5%;
}
.ts-amount {
	width: 10%;
}
.red-dot {
	background-color: #eb0002;
	height: 5px;
	width: 5px;
	position: absolute;
	border-radius: 10px;
	top: 9px;
	right: 70px;
}

.tran-table-container .tran-row {
	width: 100%;
	background: #fcfcfc;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	border-radius: 5px;
	position: relative;
	padding-block: 6px;
}
.tran-table-container .grey-line {
	width: 3px;
	height: 85%;
	background: #72738e;
	position: absolute;
	left: 3px;
	border-radius: 3px;
}
.tran-table-container .table-scroll {
	height: calc(100vh - 545px);
	min-height: 297px;
	overflow: auto;
	min-width: 1210px;
}
.tran-table-container .acs-gotopage-text {
	color: #72738e;
}
.tran-table-container .acs-paginaTion-new .page-item.active .page-link {
	background-color: #72738e;
	color: white;
}
.tran-table-container .acs-paginaTion-new .page-link {
	color: #72738e;
}
.tran-table-container .acs-paginaTion-new {
	box-shadow: 0px 4px 15px 0px #c4c4c480;
}
.free-tag {
	background: #ccfacb;
	color: #038e00;
	font-family: "Lato", sans-serif;
	font-size: 12px;
	font-weight: 600;
	padding: 4px 20px;
	border-radius: 14px;
	display: flex;
	align-items: center;
	width: fit-content;
}
.searchtransaction .form-control::placeholder {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	color: rgba(114, 115, 142, 0.5);
}
</style>
